import store from '../../../store';
import { PAGER } from '../../../constants/event';

export default class Pager {
  constructor() {
    this.isLoading = false;
    this.resetAction = '';
    this.eventStorage = {};
    this.init();
  }

  init() {
    this.submitData = {
      size: 50,
      page: 1,
      isAbortBefore: true
    };
    this.action = '';
    this.resetAction = '';
    this.isLoading = false;
  }

  storeReset() {
    if (this.resetAction) {
      store.dispatch(this.resetAction);
    }
  }

  getSubmitData(submitData = {}) {
    return { ...this.submitData, ...submitData };
  }

  setRequestOption({ action = '', resetAction = '', submitData = {} }) {
    this.init();
    this.action = action;
    this.resetAction = resetAction;
    this.submitData = this.getSubmitData(submitData);
  }

  request() {
    if (this.isLoading || this.action === '') {
      return;
    }
    this.isLoading = true;
    store.dispatch(this.action, this.submitData).then(response => {
      this.submitData.page++;
      this.isLoading = false;
      this.dispatchEvent(PAGER.COMPLETE, response);
    }, error => {
      this.dispatchEvent(PAGER.FAIL, error);
    });
  }

  next() {
    this.request();
  }

  on(event, func) {
    if (!this.eventStorage[event]) {
      this.eventStorage[event] = [];
    }
    this.eventStorage[event].push(func);
  }

  off(event, func) {
    const eventFuncList = this.eventStorage[event];
    if (!eventFuncList) {
      this.eventStorage[event] = eventFuncList.filter(eventFunc => func !== eventFunc);
    }
  }

  dispatchEvent(event, response) {
    if (this.eventStorage[event]) {
      this.eventStorage[event].forEach(func => {
        func(response);
      });
    }
  }

  remove() {
    this.eventStorage = {};
  }
}
